import {
  APPLY_PLAN,
  CREATE_DATED_PLAN,
  CREATE_TEMPLATE,
} from "../../../consts/sentryIds";
import { Button } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

import { View } from "../../View";
import { getSelectedMatrixProfile } from "../../../reducers/matrixProfile/selectors";
import { palette } from "../../../theme/palette";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    marginTop: "50px",
  },
  green: {
    background: palette.btn.greenFill,
    color: palette.typography.white.high,
    border: palette.btn.greenBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.greenFill,
    },
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const SelectPlanModalActions = ({
  onApply,
  selectedValue,
  onCreateDatePlan,
  onCreateNewTemplate,
}) => {
  const selectedProfile = useSelector(getSelectedMatrixProfile);
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Button
        className={styles.green}
        variant={"contained"}
        onClick={onCreateNewTemplate}
        sentryId={CREATE_TEMPLATE}
      >
        Create New Template
      </Button>
      <Button
        className={styles.yellow}
        variant={"contained"}
        onClick={onCreateDatePlan}
        sentryId={CREATE_DATED_PLAN}
      >
        Create Dated Plan
      </Button>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={onApply}
        disabled={!selectedProfile && !selectedValue}
        sentryId={APPLY_PLAN}
      >
        Apply
      </Button>
    </View>
  );
};
